import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import { CONFIDENTIALITY } from '../../../constants/routes';
import { Link, Modal, ThemeButton, Translation } from '../../common';
import { useAppWidthClass } from '../../../utils/hooks';

const useStyles = makeStyles(theme => ({
  backdrop: {
    background: theme.palette.background.dark
  },
  wrapper: {
    maxWidth: 384,
    width: '100%',
    margin: 16,
    borderRadius: 24
  },
  wrapperMobile: {
    marginTop: '20vh'
  },
  content: {
    padding: '40px 40px 32px 40px'
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    transition: theme.transitions.custom.fast,

    '&:hover': {
      color: theme.palette.primary.dark
    }
  },
  button: {
    marginTop: 40,
    width: '100%'
  }
}));

const CookieAgreement = ({ open, onOkClick }) => {
  const classes = useStyles();
  const { isMobileWidth } = useAppWidthClass();

  return (
    <Modal
      isOpen={open}
      backdropClassName={classes.backdrop}
      paperClassName={classNames(
        classes.wrapper,
        isMobileWidth && classes.wrapperMobile
      )}
    >
      <Box className={classes.content}>
        <Typography variant="body1" color="textPrimary">
          <Translation inline>COOKIE_BANNER_TEXT</Translation>
          &nbsp;
          <Link
            id="page.component.cookie-agreement.cookie-link"
            className={classes.link}
            to={CONFIDENTIALITY}
          >
            <Translation inline>COOKIE_BANNER_LINK</Translation>
          </Link>
        </Typography>
        <ThemeButton
          className={classes.button}
          id="page.component.cookie-agreement.ok-button"
          variant="contained"
          textKey="COOKIE_BANNER_BUTTON"
          onClick={onOkClick}
        />
      </Box>
    </Modal>
  );
};

export default CookieAgreement;
